import React, { Fragment } from "react";
import { PrivTermsImg1Src, PrivTermsImg2Src } from "../../../../resources/Assets";
import Private_20240628 from "./20240628";

export default () => {
  return (
    <Fragment>
      <Private_20240628 />
    </Fragment>
  );
};
